<div
    #importModal
    class="modal fade"
    [id]="modalId"
    tabindex="-1"
    [attr.aria-labelledby]="modalLabelId"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
>
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="border-0 shadow modal-content rounded-4 import-new-modal">
            <div class="py-5 modal-header px-7">
                <h4 class="modal-title fw-bold text-dark" [id]="modalLabelId">
                    {{ title | translate }}

                </h4>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="onClose()"></button>
            </div>

            <div class="px-20 py-10 modal-body">
                <label
                    class="text-center border border-2 border-dashed w-100 bg-light rounded-3 border-secondary d-flex flex-column align-items-center justify-content-center position-relative import-new-dropzone">
                    <div class="mb-4 rounded-circle d-flex align-items-center justify-content-center import-new-upload-icon">
                        <img src="assets/media/icons/svg/import-file.svg" class="import-new-upload-image" alt=""
                            aria-hidden="true" />
                    </div>

                    <div class="mb-2 fw-bold text-dark fs-6">
                        {{ dragText }}
                    </div>

                    <div class="text-gray-700 fs-7">
                        {{ helperText }}
                    </div>
                    <input #fileInput type="file" [accept]="acceptedFileTypes"
                        class="top-0 opacity-0 position-absolute start-0 w-100 h-100" (click)="fileInput.value = ''"
                        (change)="onFileChange($event)" />
                </label>

                <div class="mt-10" *ngIf="selectedFileName">
                    <div class="form-label fw-semibold">{{ fileLabel }}</div>

                    <div class="form-control d-flex align-items-center justify-content-between"
                        [class.border-danger]="fileError" [class.border-success]="!fileError">
                        <span>{{ selectedFileName }}</span>

                        <button type="button" class="p-0 bg-transparent border-0 btn btn-sm"
                            (click)="clearFile(fileInput)">
                            ×
                        </button>
                    </div>

                    <div class="mt-1 text-danger small" *ngIf="fileError">
                        {{ fileError }}
                    </div>
                </div>
            </div>


            <div class="px-10 pt-2 pb-8 border-0 modal-footer">
                <button type="button" class="btn btn-secondary btn-lg fw-bold me-4" data-bs-dismiss="modal"
                    (click)="onClose()">
                    {{ cancelText | translate }}

                </button>

                <button type="button" class="text-white btn btn-lg fw-bold me-4 import-new-save-button"
                    [disabled]="isSaving || selectedFile === null || !!fileError" (click)="onSave()">
                    {{ saveText | translate }}
                </button>


            </div>
        </div>
    </div>
</div>

<app-loading-dialog
    #importLoadingDialog
    [modalId]="loadingModalId"
    [title]="loadingTitle"
    [message]="loadingMessage"
    [stackAboveModal]="true"
></app-loading-dialog>

<div class="modal fade" [id]="errorModalId" tabindex="-1" [attr.aria-labelledby]="errorModalLabelId" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered import-error-dialog">
        <div class="border-0 shadow modal-content rounded-4 import-error-modal">
            <div class="py-5 modal-header px-7">
                <h4 class="modal-title fw-bold text-dark" [id]="errorModalLabelId">
                    {{ title | translate }}
                </h4>

                <button type="button" class="btn-close" aria-label="Close" (click)="closeImportError()"></button>
            </div>

            <div class="px-7 py-6 modal-body">
                <div class="mb-5 import-error-alert" *ngIf="importError?.message">
                    <span class="import-error-alert-icon" aria-hidden="true">!</span>
                    {{ importError?.message }}
                </div>

                <div class="table-responsive import-error-table-scroll" *ngIf="importError?.errors?.length">
                    <table class="mb-0 table import-error-table">
                        <thead>
                            <tr>
                                <th>ลำดับ</th>
                                <th>คอลัมน์</th>
                                <th>แถว</th>
                                <th>รายละเอียด</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let error of importError?.errors">
                                <td>{{ error.no }}</td>
                                <td>{{ error.column }}</td>
                                <td>{{ error.row }}</td>
                                <td>{{ error.description }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="px-7 pt-2 pb-6 border-0 modal-footer">
                <button type="button" class="text-white btn btn-lg fw-bold me-4 import-new-save-button"
                    (click)="closeImportError()">
                    ตกลง
                </button>
            </div>
        </div>
    </div>
</div>
